// Nationwide Topo Lines ships as two separately-tiled builds in the layer catalog: a
// generalized "zoomout" render for z11-16 and a detailed "zoomin" render for z17+.
// They are distinct layer ids, so anything drawing topo lines has to choose per zoom
// rather than pinning one id.
//
// Web pinned the zoomin id (876) at every zoom — hybrid's overlayLayerId was a
// hardcoded 876 and nothing ever consulted the zoom — so z11-16 requested detail tiles
// that the zoomout build is meant to serve. The zoomout id did not appear anywhere in
// the codebase.
export const TOPO_LINES_ZOOMIN = 876
export const TOPO_LINES_ZOOMOUT = 8134

// Nothing is served below this; above it the zoomout build covers up to the zoomin cut.
export const TOPO_LINES_MIN_ZOOM = 11
export const TOPO_LINES_ZOOMIN_MIN_ZOOM = 17

export const isTopoLinesLayer = id =>
  Number(id) === TOPO_LINES_ZOOMIN || Number(id) === TOPO_LINES_ZOOMOUT

/**
 * The layer id that should serve topo lines at this zoom, or null below the band.
 * Fractional zooms floor, matching how a tile request resolves to an integer z.
 */
export function topoLinesLayerIdForZoom(zoom) {
  const z = Math.floor(Number(zoom))
  if (!Number.isFinite(z) || z < TOPO_LINES_MIN_ZOOM) return null
  return z >= TOPO_LINES_ZOOMIN_MIN_ZOOM ? TOPO_LINES_ZOOMIN : TOPO_LINES_ZOOMOUT
}

/**
 * Zoom bands for renderers that cannot choose a URL per tile request. MapLibre raster
 * sources take a static tile template — there is no per-request hook like Google's
 * getTileUrl — so both builds go on as separate layers and the layer-level zoom range
 * decides which one is visible. maxzoom is exclusive, matching MapLibre: a layer is
 * hidden at zooms greater than or equal to its maxzoom.
 */
export const TOPO_LINES_BANDS = [
  { id: TOPO_LINES_ZOOMOUT, minzoom: TOPO_LINES_MIN_ZOOM, maxzoom: TOPO_LINES_ZOOMIN_MIN_ZOOM },
  { id: TOPO_LINES_ZOOMIN, minzoom: TOPO_LINES_ZOOMIN_MIN_ZOOM, maxzoom: null },
]
